export default {"src":"/_next/static/media/pcsql-logo.bf51942d.svg","height":42,"width":199,"blurWidth":0,"blurHeight":0};